import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ColorVariant } from '@psei/ng/api';
import { DialogService, LegacyDialogConfig } from '@psei/ng/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RegistrationCode } from '../shared/models/registration-codes.model';
import { RegistrationCodesService } from './registration-codes.service';

@Component({
  selector: 'ppb-registration-codes',
  templateUrl: './ppb-registration-codes.component.html',
  styleUrls: ['./ppb-registration-codes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PpbRegistrationCodesComponent implements OnInit, OnDestroy {

  readonly = true;
  isDataLoading = false;
  registrationCodes$: Observable<RegistrationCode[]>;
  canGenerateNewCode$: Observable<boolean>;
  currentCode: RegistrationCode;
  invalidateTooltip = $localize`:@@registration-codes.invalidate:Unieważnij`;
  private subs = new Subscription();

  constructor(
    private registrationCodesService: RegistrationCodesService,
    private dialogBoxService: DialogService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.canGenerateNewCode$ = this.registrationCodesService.canGenerateNewCode$;
    this.registrationCodes$ = this.registrationCodesService.registrationCodes$
      .pipe(
        map(tableData => tableData.payload),
        tap(_ => {
          const activeCode = _.find((code: RegistrationCode) => code.active === 'true');
          if (activeCode) {
            this.currentCode = activeCode;
          }
          this.isDataLoading = false;
          this.cd.markForCheck();
        })
      );
    this.getRegistrationCodes();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  trackById(_index: number, code: RegistrationCode): number {
    return code.id;
  }

  generateNewCode(): void {
    this.registrationCodesService.generateNew();
  }

  deactivateCode(item: RegistrationCode): void {
    if (item.active === 'false') {
      return;
    }
    this.executeDialogBox(item.id);
  }

  private executeDialogBox(id: number): void {
    this.dialogBoxService.legacy.open(this.generateDialog(id))
  }

  private generateDialog(id: number): LegacyDialogConfig<string> {
    return {
      title: $localize`:@@registration-codes.title:Czy unieważnić kod rejestracyjny?`,
      text: $localize`:@@registration-codes.text:Kod rejestracyjny straci ważność. W przypadku jeżeli został przekazany użytkownikom,
         nie będzie mógł zostać przez nich użyty do rejestracji konta.`,
      value: 'my-value',
      buttons: [
        {
          label: $localize`:@@common.cancel:Anuluj`,
          colorVariant: ColorVariant.Secondary,
          onSelect: () => this.dialogBoxService.legacy.closeCurrent(),
        },
        {
          label: $localize`:@@registration-codes.invalidate:Unieważnij`,
          colorVariant: ColorVariant.Negative,
          onSelect: () => {
            this.dialogBoxService.legacy.closeCurrent();
            this.registrationCodesService.deleteCode(id);
          },
        }
      ]
    };
  }

  private getRegistrationCodes(): void {
    this.isDataLoading = true;
    this.registrationCodesService.getRegistraionCodes();
  }
}
